import React from "react";
import PropTypes from "prop-types";
import { TextOverflow } from "utils/common";

export default function ConflictsTable({ conflicts }){
	const rows = conflicts.map((conflict) => {
		const { name, creatives } = conflict;
		const numCreatives = creatives?.length;

		return (
			<tr key={name}>
				<td className="asset-name-column">
					<TextOverflow value={name} />
				</td>
				<td className="num-creatives-column">
					{numCreatives || "-"}
				</td>
			</tr>
		);
	});

	return (
		<table className="basic-table">
			<thead>
				<tr>
					<th className="asset-name-column">Asset Name</th>
					<th className="num-creatives-column">Creative Usage</th>
				</tr>
			</thead>
			<tbody>
				{rows}
			</tbody>
		</table>
	);
}

ConflictsTable.displayName = "ConflictsTable";
ConflictsTable.propTypes = {
	conflicts: PropTypes.arrayOf(PropTypes.shape({
		name: PropTypes.string,
		creatives: PropTypes.array,
	})),
};

ConflictsTable.defaultProps = {
	conflicts: [],
};
